import React from "react";
import "./illustration.css"
import {
    Logo,
    FullLogo,
    NeuralNetwork,
    RedEllipse,
    HomeBackground,
    NonHomeBackground
} from "./HomeIllustration";
import {GreenEllipse} from "./HomeIllustration";
import {BlueEllipse} from "./HomeIllustration";
import PropTypes from "prop-types";


export default class Illustration extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            illustrationList: {
                logo: <Logo/>,
                FullLogo: <FullLogo/>,
                NeuralNetwork:  <NeuralNetwork/>,
                BlueEllipse:    <BlueEllipse/>,
                GreenEllipse:   <GreenEllipse/>,
                RedEllipse:     <RedEllipse/>,
                HomeBackground: <HomeBackground/>,
                NonHomeBackground: <NonHomeBackground/>,
            }
        }
    }

    render() {
        let {name, className, onClick} = this.props;
        let {illustrationList} = this.state;
        return(
            <div className={className} onClick={onClick}>
                {illustrationList[name]}
            </div>

        )
    }
}


Illustration.defaultProps = {
    name: "logo",
    className: "default-illustration",
}

Illustration.propTypes = {
    className: PropTypes.string,
    name: PropTypes.oneOf([
        "logo",
        "FullLogo",
        "NeuralNetwork",
        "BlueEllipse",
        "GreenEllipse",
        "RedEllipse",
        "HomeBackground",
        "NonHomeBackground"
    ]).isRequired,
}